import { identityTypeEnum } from 'assets/constants';

export const getJourneyIdentityType = () => {
    const hash = window.location.hash || '';
    const identity = hash.startsWith('#/')
        ? hash.slice(2)
        : '';

    const shortGuidRegex = /^[A-Za-z0-9]{12}$/;
    if (shortGuidRegex.test(identity))
        return identityTypeEnum.deepLinkJourney;

    return identityTypeEnum.regularJourney;
}

export const isDeepLink = () => {
    return getJourneyIdentityType() === identityTypeEnum.deepLinkJourney
}